import FormRow from "components/form/FormRow";
import ListInput from "components/form/input/ListInput";
import TextInput from "components/form/input/TextInput";
import { CompareSymbolSelectInput, GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import PS from "..";

export function PSParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={PS.field + tipoIndicadorField}
            tabFields={
                <>
                    <ParamFormRow label="Intervalo de Aderência">
                        <TextInput name="intervaloMin" label="Mínimo" type="number" />
                        <TextInput name="intervaloMax" label="Máximo" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Meta">
                        <TextInput name="meta" label="Meta (%)" type="number" />
                    </ParamFormRow>


                    <FormRow sx={{ p: 2, pl: { xs: 0, sm: 2 }, pr: { xs: 0, sm: 2 } }}>
                        <ListInput name="items" label="Pontos Amostrados">
                            <TextInput name="classificacao" label="Classificação" />
                            <CompareSymbolSelectInput name="sinalIntervaloMin" label="Sinal" />
                            <TextInput type="number" name="intervaloMin" label="Intervalo (Mín.)" />
                            <CompareSymbolSelectInput name="sinalIntervaloMax" label="Sinal" />
                            <TextInput type="number" name="intervaloMax" label="Intervalo (Máx.)" />
                        </ListInput>
                    </FormRow>
                </>
            }
            bottomFields={<></>}
        />
    );
}
